import { Component, OnInit, OnDestroy } from '@angular/core';
import { AlertConfigService, PendingSignaturesPanelItem } from '../../../../core/services/api/alert-config.service';

const POLLING_INTERVAL_MS = 60000;
const PAGE_SIZE = 10;

@Component({
  selector: 'app-pending-signatures-panel',
  templateUrl: './pending-signatures-panel.component.html',
  styleUrls: ['./pending-signatures-panel.component.scss']
})
export class PendingSignaturesPanelComponent implements OnInit, OnDestroy {
  items: PendingSignaturesPanelItem[] = [];
  currentPage = 1;
  totalCount = 0;
  pageSize = PAGE_SIZE;
  showSpinner = false;
  errorMessage: string = null;

  private pollingTimer: any;

  constructor(private alertConfigService: AlertConfigService) {}

  async ngOnInit() {
    await this.load();
    this.pollingTimer = setInterval(() => this.load(), POLLING_INTERVAL_MS);
  }

  ngOnDestroy() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
    }
  }

  async load() {
    this.errorMessage = null;
    this.showSpinner = true;
    try {
      const result = await this.alertConfigService.getPendingSignatures(this.currentPage, this.pageSize);
      this.items = result.items ?? [];
      this.totalCount = result.pagination?.totalCount ?? 0;
    } catch {
      this.errorMessage = 'No se pudo cargar el panel de firmas pendientes.';
    } finally {
      this.showSpinner = false;
    }
  }

  get totalPages(): number {
    return Math.ceil(this.totalCount / this.pageSize);
  }

  async goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    await this.load();
  }

  formatMinutes(minutes: number): string {
    if (minutes < 60) return `${Math.round(minutes)}min`;
    const hours = Math.floor(minutes / 60);
    const remaining = Math.round(minutes % 60);
    return remaining > 0 ? `${hours}h ${remaining}min` : `${hours}h`;
  }
}
